import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Upload, Check } from 'react-feather';
import {
    FormTitle, FormSubtitle, FormGroup, Label, UploadBox,
    UploadText, UploadSubtext, FileUploadedBanner, FileName, StyledInput,
    CheckboxLabel, ErrorText, RequiredBadge
} from '../styles';

const documentsConfig = [
    { id: 'docCertificateOfIncorporation', label: 'Certificate of Incorporation', desc: 'Official formation document' },
    { id: 'docRegulatoryLicense', label: 'Regulatory License / Registration', desc: 'FCA, FinCEN, or local equivalent' },
    { id: 'docAMLPolicy', label: 'AML/KYC Policy Summary', desc: 'Summary or full policy document' },
    { id: 'docSignerId', label: 'ID of Authorized Signatory', desc: 'Passport or National ID' },
    { id: 'docOrgChart', label: 'Organizational Chart', desc: 'Ownership structure and percentages' },
    { id: 'docFinancialStatements', label: 'Financial Statements or Source of Funds Documentation', desc: 'Most recent tax returns, bank statements, or certified asset verification (last 2 years)' },
];

const Step4Documentation = () => {
    const { register, watch, setValue, formState: { errors } } = useFormContext();

    const handleFileDelete = (id) => {
        setValue(id, null, { shouldValidate: true });
    };

    return (
        <div>
            <FormTitle>Required Documents</FormTitle>
            <FormSubtitle>Upload the necessary documents to comply with cross-border banking regulations.</FormSubtitle>

            {documentsConfig.map(doc => {
                const fileList = watch(doc.id);
                const file = fileList && fileList.length > 0 ? fileList[0] : null;

                return (
                    <FormGroup key={doc.id}>
                        <Label>{doc.label}<RequiredBadge>*</RequiredBadge></Label>
                        {file ? (
                            <FileUploadedBanner>
                                <Check size={20} />
                                <FileName>{file.name}</FileName>
                                <button
                                    type="button"
                                    onClick={() => handleFileDelete(doc.id)}
                                    style={{ background: 'none', border: 'none', color: 'inherit', opacity: 0.8, cursor: 'pointer', fontSize: '13px', fontWeight: '500', textDecoration: 'underline' }}
                                >
                                    Remove
                                </button>
                            </FileUploadedBanner>
                        ) : (
                            <>
                                <UploadBox htmlFor={doc.id} $error={!!errors[doc.id]}>
                                    <Upload size={24} />
                                    <UploadText>Click to upload or drag and drop</UploadText>
                                    <UploadSubtext>{doc.desc} (PDF, JPG, PNG)</UploadSubtext>
                                </UploadBox>
                                <StyledInput
                                    type="file"
                                    id={doc.id}
                                    {...register(doc.id)}
                                    style={{ display: 'none' }}
                                    accept=".pdf,.jpg,.jpeg,.png"
                                />
                                {errors[doc.id] && <ErrorText>{errors[doc.id].message}</ErrorText>}
                            </>
                        )}
                    </FormGroup>
                );
            })}

            <CheckboxLabel $error={!!errors.agreeTerms}>
                <input type="checkbox" {...register('agreeTerms')} />
                <span>
                    By proceeding, I declare on behalf of the institution that the information provided is correct,
                    and I agree to the{' '}
                    <button type="button" onClick={(e) => e.preventDefault()} style={{ background: 'none', border: 'none', padding: 0, color: 'inherit', fontWeight: '700', cursor: 'pointer', textDecoration: 'underline' }}>
                        NYBANQ Platform Terms
                    </button>{' '}and{' '}
                    <button type="button" onClick={(e) => e.preventDefault()} style={{ background: 'none', border: 'none', padding: 0, color: 'inherit', fontWeight: '700', cursor: 'pointer', textDecoration: 'underline' }}>
                        Privacy Policy
                    </button>.
                </span>
            </CheckboxLabel>
            {errors.agreeTerms && <ErrorText style={{ marginTop: '8px' }}>{errors.agreeTerms.message}</ErrorText>}
        </div>
    );
};

export default Step4Documentation;
